<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/89/title-bg.png" alt="" />
      <div class="technological-process">
        
        <div class="sxcl">
          <img class="top" src="./../assets/imgs/89/title-1.png" alt="" />
          <div class="content">
            本政策支持对象为经成都高新区认定的人才及税收和统计关系在成都高新区的企业、新型研发事业单位、科研院所。企业、新型研发事业单位、科研院所管理规范，无不良信用记录，自觉遵守安全生产、环境保护等方面的法律法规，近三年未发生重大安全事故。具体条款中，对支持对象另有规定的，从其规定执行。本政策实行预算管理和总量控制。
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="./../assets/imgs/89/title-2.png" alt="" />
          <div class="content">
           本政策与其他政策相重叠的事项按照就高不重复原则执行。享受本政策的项目原则上不能再申报区级其他同类政策。本实施细则实施过程中，因国家法律法规和省市相关规定调整而产生冲突的，以调整后的规定为准。
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="./../assets/imgs/89/title-3.png" alt="" />
          <div class="content" style="fontWeight:bold;fontSize:0.3rem">
           具体申报时间以成都高新区官网或成都高新区科技创新局相关信息发布平台通知为准。
          </div>
        </div>
        <div class="zccl">
            <img
                class="top"
                src="./../assets/imgs/89/title-4.png"
                alt=""
            />
            <div class="content">
                <div class="des">
                    <div class="title">
                      <div class="circle"></div>
                      （一）支持引进急需科技创新领军人才
                    </div>
                    支持成都高新区新型研发事业单位、科研院所面向全球引进符合成都高新区主导产业方向，具有世界科技前沿技术和关键核心技术攻关能力的急需科技创新领军人才，经认定给予3年、每年最高500万元人才补贴，最高500万元安家补贴或赠予1套专家公寓。支持科技创新领军人才团队在成都高新区开展项目研发和成果转化，经评审可给予最高1亿元经费支持。
                </div>
                <div class="des">
                  <div class="title">
                      <div class="circle"></div>
                      （二）支持引进急需产业创新领军人才
                    </div>
                    支持成都高新区重点企业根据关键核心技术研发需要，面向全球引进符合成都高新区主导产业建圈强链方向、具有突出技术创新能力的急需产业创新领军人才，经认定给予3年、每年最高500万元人才补贴，最高500万元安家补贴或赠予1套专家公寓
                </div>
                <div class="des">
                    <div class="title">
                      <div class="circle"></div>
                      （三）建立“一对一”配套服务机制
                    </div>
                    搭建领军人才“一对一”数字化服务平台，及时响应和协调解决人才诉求。设立领军人才专业服务机构，对人才及其家属就子女教育、医疗服务、养老服务、住房保障、交通出行、政务服务、金融服务、政策申报等方面全方位量身定制清单式服务。
                </div>
                
            </div>
        </div>
        <div class="sbcl">
            <img
                class="top"
                src="./../assets/imgs/89/title-5.png"
                alt=""
            />
            <div class="content">
                <div class="des">
                    <div class="item">
                        <div class="line"></div>
                        <div class="dot">1</div>
                        成都高新区相关部门制定政策申报通知和申报指南，在成都高新区官网和高新通公告；
                    </div>
                    <div class="item">
                        <div class="line"></div>
                        <div class="dot">2</div>
                        申报单位按照通知要求准备并提交申报材料；
                    </div>
                    <div class="item">
                        <div class="line"></div>
                        <div class="dot">3</div>
                        审核部门对申报材料进行初审，如有需要组织专家对申报材料进行评审；
                    </div>
                    <div class="item">
                        <div class="line"></div>
                        <div class="dot">4</div>
                        审核部门根据材料审核情况、专家评审情况（如需），必要时进行现场考察后，拟定资金安排建议方案，按部门资金审核流程审议通过后，上报管委会审批；
                    </div>
                    <div class="item">
                        <div class="line" style="height: 120%;"></div>
                        <div class="dot">5</div>
                        方案获批后，审核部门将拟支持名单在成都高新区官网进行公示，公示期5个工作日。公示期间，发现申报单位有弄虚作假、知识产权纠纷以及违法违规等情况，经查实后取消扶持资格；
                    </div>
                    <div class="item">
                        <div class="dot">6</div>
                        对公示期满无异议的，由审核部门办理资金拨付手续。
                    </div>         
                </div>
            </div>
        </div>
        <div class="zccl">
            <img
                class="top"
                src="./../assets/imgs/89/title-6.png"
                alt=""
            />
            <div class="content">
                <div class="des">
                    <div class="title">
                      <div class="circle" style="marginRight:0.1rem"></div>
                      （一）支持引进科技创新领军人才
                    </div>
                    <div>咨询电话：<a href="tel:028-85145512">028-85145512</a> 赵老师</div>
                    <div>责任单位：成都高新区科技创新局人才发展处</div>
                </div>
                <div class="des">
                  <div class="title">
                      <div class="circle"></div>
                      （二）支持引进急需产业创新领军人才
                    </div>
                    <div>咨询电话：<a href="tel:028-62037252">028-62037252</a> 黄老师</div>
                    <div>责任单位：成都高新区科技创新局人才发展处</div>
                </div>
                
            </div>
        </div>
        <!-- <div class="contact">
          <img class="top" src="./../assets/imgs/84/title-6.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-88211208">028-88211208</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              县人社局
            </div>
          </div>
        </div> -->
        <div class="codes">
          <img class="code" src="../assets/imgs/89/code.png" />
          <img class="text" src="../assets/imgs/89/text.png" />
        </div>
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }
  .technological-process {
    transform: translateY(-2.3rem);
   
    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;
        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }
    .zccl {
      position: relative;
      margin-top: 0.22rem;
      font-size: 0.26rem;
      .top {
          width: 7.03rem;
          height: 1.37rem;
          margin-left: -0.18rem;
      }
      
      .content {
          width: 6.85rem;
          background: #E8EEFF;
          margin: -0.45rem auto 0;
          padding: 0.33rem;
          box-sizing: border-box;
          border-radius: 0rem 0rem 0.26rem 0.26rem;
          padding-top: 0.28rem;
          
          font-weight: 500;
          text-align: left;
          color: #4e4e4e;
          
          .des {
              color: #4e4e4e;
              text-align: left;
              background: #ffffff;
              border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
              padding: 0.35rem 0.23rem 0.3rem;
              margin-top: 0.9rem;
              position: relative;
              text-align: left;
              line-height: 0.44rem;
             
              color: #4E4E4E;
              font-size: 0.26rem;
               font-weight: normal;
              .title {
                 font-weight: bold;
                  position: absolute;
                  top: -0.6rem;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 100%;
                  // height: 0.67rem;
                  font-size: 0.3rem;
                  
                  // border: 1px solid red;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  .circle{
                    width: 0.22rem;
                    height: 0.22rem;
                    border: 0.06rem solid #FF6D60;
                    border-radius: 50%;
                  }
              }
              
          }
      }
    }
   
     .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }
            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.34rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                
                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.1rem 0.23rem 0.3rem;
                    position: relative;
                    
                    .item {
                        margin-top: 0.35rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;
                        color: #4E4E4E;
                        font-size: 0.26rem;
                        font-weight: 500;
                        line-height: 0.44rem;
                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            top: 0.2rem;
                            z-index: 0;

                            //   background-color: #739bfe;
                        }
                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }
    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }
    
    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }
            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }
            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;
              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .text {
        height: 0.61rem;
      }
    }
  }
}
</style>
